/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Misc_Donatekey_Title1Inputs */

const id_misc_donatekey_title1 = /** @type {(inputs: Misc_Donatekey_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sumbangkan Kunci`)
};

const ms_misc_donatekey_title1 = /** @type {(inputs: Misc_Donatekey_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Derma Kunci`)
};

const da_misc_donatekey_title1 = /** @type {(inputs: Misc_Donatekey_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Donér en Nøgle`)
};

const de_misc_donatekey_title1 = /** @type {(inputs: Misc_Donatekey_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schlüssel spenden`)
};

const en_us2_misc_donatekey_title1 = /** @type {(inputs: Misc_Donatekey_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Donate a Key`)
};

const es_es2_misc_donatekey_title1 = /** @type {(inputs: Misc_Donatekey_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dona una clave`)
};

const es_mx2_misc_donatekey_title1 = /** @type {(inputs: Misc_Donatekey_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Donar una llave`)
};

const fil_misc_donatekey_title1 = /** @type {(inputs: Misc_Donatekey_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mag-donate ng Key`)
};

const fr_misc_donatekey_title1 = /** @type {(inputs: Misc_Donatekey_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faire don d'une clé`)
};

const it_misc_donatekey_title1 = /** @type {(inputs: Misc_Donatekey_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dona una chiave`)
};

const hu_misc_donatekey_title1 = /** @type {(inputs: Misc_Donatekey_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kulcs adományozása`)
};

const nl_misc_donatekey_title1 = /** @type {(inputs: Misc_Donatekey_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doneer een sleutel`)
};

const no_misc_donatekey_title1 = /** @type {(inputs: Misc_Donatekey_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doner en nøkkel`)
};

const pl_misc_donatekey_title1 = /** @type {(inputs: Misc_Donatekey_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przekaż klucz`)
};

const pt_br2_misc_donatekey_title1 = /** @type {(inputs: Misc_Donatekey_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doe uma chave`)
};

const pt_misc_donatekey_title1 = /** @type {(inputs: Misc_Donatekey_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doar uma chave`)
};

const ro_misc_donatekey_title1 = /** @type {(inputs: Misc_Donatekey_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Donează o cheie`)
};

const fi_misc_donatekey_title1 = /** @type {(inputs: Misc_Donatekey_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lahjoita avain`)
};

const sv_misc_donatekey_title1 = /** @type {(inputs: Misc_Donatekey_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Donera en nyckel`)
};

const vi_misc_donatekey_title1 = /** @type {(inputs: Misc_Donatekey_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quyên góp Key`)
};

const tr_misc_donatekey_title1 = /** @type {(inputs: Misc_Donatekey_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anahtar Bağışla`)
};

const cs_misc_donatekey_title1 = /** @type {(inputs: Misc_Donatekey_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Darovat klíč`)
};

const bg_misc_donatekey_title1 = /** @type {(inputs: Misc_Donatekey_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дарете ключ`)
};

const ru_misc_donatekey_title1 = /** @type {(inputs: Misc_Donatekey_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пожертвовать ключ`)
};

const uk_misc_donatekey_title1 = /** @type {(inputs: Misc_Donatekey_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пожертвувати ключ`)
};

const ar_misc_donatekey_title1 = /** @type {(inputs: Misc_Donatekey_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التبرع بمفتاح`)
};

const hi_misc_donatekey_title1 = /** @type {(inputs: Misc_Donatekey_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कुंजी दान करें`)
};

const th_misc_donatekey_title1 = /** @type {(inputs: Misc_Donatekey_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`บริจาคคีย์`)
};

const ja_misc_donatekey_title1 = /** @type {(inputs: Misc_Donatekey_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`キーを寄付`)
};

const zh_cn2_misc_donatekey_title1 = /** @type {(inputs: Misc_Donatekey_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`捐赠Key`)
};

const zh_hant1_misc_donatekey_title1 = /** @type {(inputs: Misc_Donatekey_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`捐贈Key`)
};

const ko_misc_donatekey_title1 = /** @type {(inputs: Misc_Donatekey_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`키 기부하기`)
};

/**
* | output |
* | --- |
* | "Donate a Key" |
*
* @param {Misc_Donatekey_Title1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const misc_donatekey_title1 = /** @type {((inputs?: Misc_Donatekey_Title1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Misc_Donatekey_Title1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_misc_donatekey_title1(inputs)
	if (locale === "ms") return ms_misc_donatekey_title1(inputs)
	if (locale === "da") return da_misc_donatekey_title1(inputs)
	if (locale === "de") return de_misc_donatekey_title1(inputs)
	if (locale === "en-US") return en_us2_misc_donatekey_title1(inputs)
	if (locale === "es-ES") return es_es2_misc_donatekey_title1(inputs)
	if (locale === "es-MX") return es_mx2_misc_donatekey_title1(inputs)
	if (locale === "fil") return fil_misc_donatekey_title1(inputs)
	if (locale === "fr") return fr_misc_donatekey_title1(inputs)
	if (locale === "it") return it_misc_donatekey_title1(inputs)
	if (locale === "hu") return hu_misc_donatekey_title1(inputs)
	if (locale === "nl") return nl_misc_donatekey_title1(inputs)
	if (locale === "no") return no_misc_donatekey_title1(inputs)
	if (locale === "pl") return pl_misc_donatekey_title1(inputs)
	if (locale === "pt-BR") return pt_br2_misc_donatekey_title1(inputs)
	if (locale === "pt") return pt_misc_donatekey_title1(inputs)
	if (locale === "ro") return ro_misc_donatekey_title1(inputs)
	if (locale === "fi") return fi_misc_donatekey_title1(inputs)
	if (locale === "sv") return sv_misc_donatekey_title1(inputs)
	if (locale === "vi") return vi_misc_donatekey_title1(inputs)
	if (locale === "tr") return tr_misc_donatekey_title1(inputs)
	if (locale === "cs") return cs_misc_donatekey_title1(inputs)
	if (locale === "bg") return bg_misc_donatekey_title1(inputs)
	if (locale === "ru") return ru_misc_donatekey_title1(inputs)
	if (locale === "uk") return uk_misc_donatekey_title1(inputs)
	if (locale === "ar") return ar_misc_donatekey_title1(inputs)
	if (locale === "hi") return hi_misc_donatekey_title1(inputs)
	if (locale === "th") return th_misc_donatekey_title1(inputs)
	if (locale === "ja") return ja_misc_donatekey_title1(inputs)
	if (locale === "zh-CN") return zh_cn2_misc_donatekey_title1(inputs)
	if (locale === "zh-Hant") return zh_hant1_misc_donatekey_title1(inputs)
	return ko_misc_donatekey_title1(inputs)
});
export { misc_donatekey_title1 as "misc.donateKey.title" }